import { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Typography } from '@material-ui/core';
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelScanningService from "./LabelScanningService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import DefaultButton from "../../componentes/button/DefaultButton";
import { PrinterClientAutocomplete } from "../../componentes/autocomplete/PrinterClientAutocomplete";

export default function LabelScanningGeneric() {

	const { t } = useTranslation();
	const { control } = useForm();

	const userId = sessionStorage.getItem("userId");
	const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);
	const initialState = {
		userId: Number(userId) ?? 0,
		idClient: 3,
		success: false,
		error: false,
		idProduct: 0,
		status: 1,
		productName: "",
		idLayoutEtiqueta: 0,
		batch: "",
		labelQuantity: 0,
		idPrinter: 0
	};


	const reducer = (state, action) => {
		switch (action.type) {
			case 'update':
				return { ...state, ...action.data }
			case "clear":
				return { ...initialState }
			case 'success':
				return { ...state, success: true, error: false }
			case 'error':
				return { ...state, success: false, error: true }
			case 'close_alert':
				return { ...state, success: false, error: false }
			default:
				return new Error();
		}
	}

	const [state, dispatch] = useReducer(reducer, initialState);
	const [message, setMessage] = useState("");

	const handleChange = (event) => {
		const { name, value } = event.target;

		if (name === "productName") {

			if (!value) {
				dispatch({ type: "update", data: { idProduct: 0 } });
				return;
			}

			dispatch({ type: 'update', data: { idProduct: value } });
			return;
		}

		dispatch({ type: 'update', data: { [name]: value } });
	};

	const handleCloseAlertProduct = () => {
		dispatch({ type: 'close_alert' });
		// setError(false);
	};

	const handleClearAll = () => {
		dispatch({ type: 'clear' });
		dispatch({ type: 'close_alert' });
		// setError(false);
	};

	const canPrintProduct = () => {

		if (state.idClient === 1 || state.idClient === 2 || state.labelQuantity <= 0 || state.idProduct === 0 || state.batch === "" || state.idPrinter === 0) {
			setMessage(t("fillRequiredFields"));
			dispatch({ type: 'error' });
			// setError(true);
			return false;
		}

		// setError(false);
		dispatch({ type: 'sucess' });
		return true;
	};


	const handlePrintGenericLabel = () => {

		if (!canPrintProduct()) {
			return;
		}

		// Primeiro pega os dados da etiqueta
		callUpdateGenericLabelData()
			.then((labelDataAtualizado) => {

				const request = {
					...state,
					...labelDataAtualizado,                 // usa os valores novos
					labelQuantity: Number(state.labelQuantity) ?? 0
				};

				// Agora sim envia ao backend
				return LabelScanningService.insertLabelGeneric(request);
			})
			.then((response) => {
				setMessage(t("printSuccess"));
				dispatch({ type: "success" });
				dispatch({ type: 'clear' });
			})
			.catch((e) => {
				console.log(e);
				setMessage(t("printError"));
				dispatch({ type: "error" });
			});
	};



	const callUpdateGenericLabelData = () => {
		const request = {
			...state,
			idProduct: state.idProduct
		};

		return LabelScanningService
			.getLabelGenericData(request)
			.then((response) => {

				const updated = {
					productName: response.data.productName,
					ean: response.data.ean,
					idLayoutEtiqueta: response.data.idLayoutEtiqueta,
					label: replaceZplVariables(response.data)
				};

				dispatch({
					type: "update",
					data: updated
				});

				// retorna para o encadeamento
				return updated;
			});
	};



	const updateGenericLabelData = (labelGenericData) => {

		const zpl = replaceZplVariables(labelGenericData);
		dispatch({
			type: 'update',
			data: {
				...state,
				productName: labelGenericData.productName,
				ean: labelGenericData.ean,
				idLayoutEtiqueta: labelGenericData.idLayoutEtiqueta,
				label: zpl
			}
		});

	}

	const replaceZplVariables = (labelGenericData) => {

		const zpl = labelGenericData.zplTemplate
			.replace(/#NomeProduto#/g, labelGenericData.productName)
			.replace(/#Lote#/g, state.batch)
			.replace(/#EAN#/g, labelGenericData.ean)

		return zpl;
	}



	return (
		<>
			<DefaultScreenAccordion
				isConsult
				title="labelScanning"
				fields={
					<>
						<GridItemContainer>
							<CustomAlert
								error={state.error}
								success={state.success}
								message={message}
								warning={state.warningProduct}
								handleCloseAlert={handleCloseAlertProduct}
								snackbar
								autoClose
							/>
							<GridInputRow>
								{loggedIdClient === 0 ?
									<Grid item xs={12} sm={6} md={2}>
										<div style={{
											pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
											opacity: loggedIdClient !== 0 ? 0.8 : 1
										}}>
											<DefaultAutocomplete
												iconLabelSwitch={
													<IconLabelSwitch
														name={loggedIdClient !== 0 ? "unLock" : "user"}
														labelName="client"
													/>
												}
												name="idClient"
												onChange={loggedIdClient !== 0 ? undefined : handleChange}
												disabled={loggedIdClient !== 0}
												value={state.idClient}
												defaultSize
												useApi
												endpoint='GetClientGeneric'
												error={state.error && !state.idClient}

											/>
										</div>
									</Grid> : null}

								<Grid item xs={12} sm={3} md={3}>
									<DefaultAutocomplete
										iconLabelSwitch={
											<IconLabelSwitch name="productName" labelName="productName" />
										}
										onChange={handleChange}
										name="idProduct"
										value={state.idProduct}
										defaultSize
										useApi
										endpoint='GetProductGeneric'
										error={state.error && state.idProduct === 0}
									/>
								</Grid>

								<Grid item xs={12} sm={3} md={3}>
									<InputField
										name="batch"
										control={control}
										defaultValue=""
										onChange={handleChange}
										value={state.batch}
										length={30}
										error={state.error && state.batch === ""}
									/>
								</Grid>

								<Grid item xs={12} sm={3} md={3}>
									<InputField
										name="labelQuantity"
										control={control}
										type="number"
										defaultValue=""
										onChange={handleChange}
										value={state.labelQuantity}
										length={30}
										error={state.error && state.labelQuantity <= 0}
									/>
								</Grid>
								<Grid item xs={6} md={3}>
									<PrinterClientAutocomplete
										name="idPrinter"
										onChange={handleChange}
										value={state.idPrinter}
										label={t("printer")}
										defaultSize
										useApi
										endPointData={{ idClient: state.idClient }}
										endpoint='GetPrinterClient'
										//endpoint='GetPrinter'
										error={state.error && state.idPrinter === 0}
									/>
								</Grid>
							</GridInputRow>

							<Grid item xs={4} sm={3} md={2}>
								<DefaultButton print className="primaryButton" onClick={handlePrintGenericLabel} />
							</Grid>
							<Grid item xs={4} sm={3} md={2}>
								<DefaultButton clear className="secondaryButton" onClick={handleClearAll} />
							</Grid>
						</GridItemContainer>
					</>
				}
			/>
		</>
	);
};
